import { render, staticRenderFns } from "./QueueList.vue?vue&type=template&id=1ebc745b&scoped=true&"
import script from "./QueueList.vue?vue&type=script&lang=js&"
export * from "./QueueList.vue?vue&type=script&lang=js&"
import style0 from "./QueueList.vue?vue&type=style&index=0&id=1ebc745b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebc745b",
  null
  
)

export default component.exports